export default [
    {
        name: "nameAr",
        label: "Arabic Name",
        type: "String",
    },
    {
        name: "nameEn",
        label: "English Name",
        type: "String",
    },
    {
        name: "id",
        label: "ID",
        type: "number",
    },
    {
        name: "cityRequired",
        label: "City Required",
        type: "String",
    },
    {
        name: "areaRequired",
        label: "Area Required",
        type: "String",
    },
    {
        name: "locationRequired",
        label: "Location Required",
        type: "String",
    },
    {
        name: "createdAt",
        label: "Creation Date",
        type: "date",
    },
    {
        name: "updatedAt",
        label: "Last Update Date",
        type: "date",
    },
];
